import enquire from 'enquire.js'
import { Swiper, Navigation } from 'swiper'
Swiper.use([Navigation])

export default () => {
    const servicesInfographic = document.querySelector('.services-infographic')

    enquire.register('screen and (max-width: 64em)', {
        match: function () {
            if (servicesInfographic) {
                setTimeout(() => { servicesInfographic.closest('.js-reframe').style.display = 'none' }, 1000)
                document.querySelector('.services-slider').style.display = 'block'
                // eslint-disable-next-line
                new Swiper('.services-slider', {
                    spaceBetween: 20,
                    slidesPerView: 'auto',
                    loop: true,
                    slidesPerGroup: 1,
                    // centeredSlides: true,
                    navigation: {
                        nextEl: '.partners-slider__next',
                        prevEl: '.partners-slider__previous',
                    },
                })
            }
        },
        unmatch: function () {
            if (servicesInfographic) {
                servicesInfographic.closest('.js-reframe').style.display = 'block'
                document.querySelector('.services-slider').style.display = 'none'
            }
        },
    })
}

// export default () => {
//     const elInfographicLayers = document.querySelectorAll('[data-infographic-layer]')
//
//     Array.from(elInfographicLayers).forEach((layer) => {
//         layer.addEventListener('click', function () {
//             const targetIndex = this.dataset.index
//             const elTargetCopy = document.querySelector(`[data-infographic-copy="${targetIndex}"]`)
//             Array.from(document.querySelectorAll('[data-infographic-copy]')).forEach((copy) => {
//                 if (copy.dataset.active) {
//                     delete copy.dataset.active
//                 }
//             })
//             elTargetCopy.dataset.active = 'true'
//         })
//     })
// }
